export function supplementalInfoErrorMessage(error: unknown, fallback: string): string | string[] {
  const response = (error as { response?: { data?: { data?: unknown; message?: unknown } } })?.response?.data;
  const details = response?.data;
  if (typeof details === 'string') return details;
  if (Array.isArray(details) && details.every(item => typeof item === 'string')) return details;
  return typeof response?.message === 'string' && response.message.trim() ? response.message : fallback;
}
